import { useQuery } from "react-query";
import { getCompanySuspensions } from "./gateway";

function useGetCompanySuspensions() {
  return useQuery({
    queryKey: ["companySuspensions"],
    queryFn: getCompanySuspensions,
  });
}

export default useGetCompanySuspensions;
